import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { SiteService } from '../../services';
import { editedSiteLabelsAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_SITE_LABELS),
    switchMap(action =>
      SiteService.editLabels(action.site, action.orgId, store).pipe(
        map(data => editedSiteLabelsAction(data)),
        catchError(retryAuthentication(action$, 'epics/sites/editSiteLabels'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/sites/editSiteLabels.js